'use strict';

var themes = require('@wow/themes');

const {
  colors: {
    transparent,
    secondary,
    white
  }
} = themes.themeChakra;
const CloseButtonChakra = {
  baseStyle: {
    borderRadius: '0.25rem',
    position: 'relative',
    backgroundColor: transparent,
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: transparent
  },
  variants: {
    light: {
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: transparent,
      svg: {
        path: {
          fill: secondary[600]
        }
      },
      _hover: {
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        svg: {
          path: {
            fill: secondary[600]
          }
        }
      },
      _active: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
      },
      _focusVisible: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)'
      }
    },
    dark: {
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: transparent,
      svg: {
        path: {
          fill: white
        }
      },
      _hover: {
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        svg: {
          path: {
            fill: white
          }
        }
      },
      _active: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)'
      },
      _focusVisible: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)'
      }
    }
  },
  sizes: {
    sm: {
      w: '24px',
      h: '24px',
      svg: {
        w: '12px',
        h: '12px'
      }
    },
    md: {
      w: '32px',
      h: '32px',
      svg: {
        w: '16px',
        h: '16px'
      }
    },
    lg: {
      w: '40px',
      h: '40px',
      svg: {
        w: '21px',
        h: '21px'
      }
    }
  },
  defaultProps: {
    size: 'md',
    variant: 'light'
  }
};

exports.CloseButtonChakra = CloseButtonChakra;
